import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import i18n from "i18n/i18n";
import { withRouter } from "react-router-dom";
import ErrorPage from "./ErrorPage";

const defaultState = {
  hasError: false,
  error: undefined,
  errorInfo: undefined
};

const isDev = process.env.NODE_ENV === "development";

class ErrorBoundary extends Component {
  state = { ...defaultState };

  componentDidCatch(error, errorInfo) {
    this.setState({
      errorInfo
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      this.state.hasError &&
      prevProps.location.pathname !== this.props.location.pathname
    ) {
      this.setState(defaultState);
    }
  }

  static getDerivedStateFromError(error) {
    console.error(error);
    return { hasError: true, error };
  }

  render() {
    return this.state.hasError ? (
      isDev ? (
        <ErrorPage devError>
          <h3>{i18n.t("details")}</h3>
          <pre>
            {this.state.error.toString()}
            <hr />
            {this.state.error.name}
            <br />
            Line {this.state.error.lineNumber} - {this.state.error.fileName}
          </pre>
          <h3>{i18n.t("component_stack")}</h3>
          <pre>{this.state.errorInfo?.componentStack}</pre>
        </ErrorPage>
      ) : (
        <ErrorPage>
          <h2>{i18n.t("oops_something_went_wrong")}</h2>
          <p>{i18n.t("try_to_refresh_the_page_or_log_in_and_log_out_again")}</p>
        </ErrorPage>
      )
    ) : (
      this.props.children
    );
  }
}

export default withTranslation()(withRouter(ErrorBoundary));
